<template>
  <div class="container text-center">
    <titular />
    <estadistica></estadistica>
  </div>
</template>

<style lang="scss">
</style>

<script>
import Estadistica from "../components/EstadisticaTrabajador.vue";

export default {
  name: "Home",
  components: {
    Estadistica,
  },
  data() {
    return {};
  },
};
</script>